import { RotateCcw, TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

/** The boundary is a class (only classes can catch render errors), so its
 *  fallback lives here — a function component can call `useTranslation`. */
export const WidgetErrorFallback = ({ onRetry }: { onRetry: () => void }) => {
  const { t } = useTranslation(["common"]);

  return (
    <div className="flex h-full flex-col items-center justify-center gap-1.5 px-2 text-center">
      <span className="grid size-7 place-items-center rounded-full bg-danger-muted text-danger">
        <TriangleAlert size={14} aria-hidden />
      </span>
      <p className="text-widget-label font-semibold text-foreground">
        {t("common:dashboard_grid.widget_could_not_load")}
      </p>
      <button
        type="button"
        onClick={onRetry}
        className="widget-target widget-focus flex items-center gap-1 rounded-full px-2 py-0.5 text-widget-label font-semibold text-primary transition-colors hover:bg-primary-muted"
      >
        <RotateCcw size={10} aria-hidden />
        {t("common:buttons.try_again")}
      </button>
    </div>
  );
};
